/*
 *
 * ChargebackDownloadPopup
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 15-Sep-2025
 */

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import ChargebackDownloadPopup from './ChargebackDownloadPopup'
import { doHidePopup } from 'Store/actions/popup'
import { nullSafe } from 'Utility/globalMethods'
import { doGetCompensationDownload, doGetRefundsDownload } from 'Route/Costs/modules/CostsActions'

const mapDispatchToProps = (dispatch) => ({
  doGetCompensationDownload: (params) => dispatch(doGetCompensationDownload(params)),
  doGetRefundsDownload: (params) => dispatch(doGetRefundsDownload(params)),
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = (state) => ({
  data: nullSafe(() => state.Costs.dataToDownload, {}),
  isLoading: nullSafe(() => (state.loading.localLoading.get_refunds_download || state.loading.localLoading.get_compensation_download), false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ChargebackDownloadPopup)
